module.exports = __webpack_public_path__ + "static/media/cloud-lock.cdb5fd99.svg";